import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Col, Nav, NavItem, Offcanvas, Row } from 'reactstrap';

function Header() {
	const [collapseOpen, setCollapseOpen] = useState(false);
	const [activeNav, setActiveNav] = useState('welcome');
	const collapseToggle = () => {
		setCollapseOpen(!collapseOpen);
	};
	return (
		<>
			<div className='custom__navbar text-white'>
				<div className='custom__width d-flex'>
					<i
						className='fas fa-stream mt-2 fa-2x pointer'
						onClick={collapseToggle}
					></i>
					<p className='menu mt-3 ms-3'>Menu</p>
					<p className='mx-auto page__title'>Discover Mleiha</p>
				</div>
			</div>
			<Offcanvas
				isOpen={collapseOpen}
				toggle={collapseToggle}
				className='sidebar__collapse text-white'
			>
				<div className='sidebar__collapse-child'>
					<Nav vertical className='mt-3 custom__nav'>
						<div className='text-center image__container'>
							<img
								src='https://discovershurooq.ae/static/media/logo2.aae2568b.png'
								alt=''
								className='img-fluid logo'
							/>
						</div>
						<NavItem
							className={`mt-5 ${
								activeNav == 'welcome' && 'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='far fa-star'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() => setActiveNav('welcome')}
									>
										Welcome
									</NavLink>
								</Col>
							</Row>
						</NavItem>
						<NavItem
							className={`${
								activeNav == 'shopping' && 'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='fa fa-shopping-bag'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() => setActiveNav('shopping')}
									>
										Shopping
									</NavLink>
								</Col>
							</Row>
						</NavItem>
						<NavItem
							className={`${
								activeNav == 'productivity' &&
								'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='fa fa-mouse-pointer'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() =>
											setActiveNav('productivity')
										}
									>
										Productivity
									</NavLink>
								</Col>
							</Row>
						</NavItem>
						<NavItem
							className={`${
								activeNav == 'privacy' && 'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='fa fa-lock'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() => setActiveNav('privacy')}
									>
										Privacy
									</NavLink>
								</Col>
							</Row>
						</NavItem>
						<NavItem
							className={`${
								activeNav == 'performance' &&
								'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='fa fa-tachometer-alt'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() =>
											setActiveNav('performance')
										}
									>
										Performance
									</NavLink>
								</Col>
							</Row>
						</NavItem>
						<NavItem
							className={`${
								activeNav == 'accessible' &&
								'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='fa fa-briefcase'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() =>
											setActiveNav('accessible')
										}
									>
										Accessibility & tools
									</NavLink>
								</Col>
							</Row>
						</NavItem>
						<NavItem
							className={`${
								activeNav == 'getstart' && 'custom__nav__active'
							}`}
						>
							<Row>
								<Col xs='2'>
									<i className='far fa-comment-alt'></i>
								</Col>
								<Col>
									<NavLink
										to='#'
										onClick={() => setActiveNav('getstart')}
									>
										Get started
									</NavLink>
								</Col>
							</Row>
						</NavItem>
					</Nav>
				</div>
			</Offcanvas>
		</>
	);
}

export default Header;
